import { createFileRoute } from "@tanstack/react-router";
import { ExperimentsLibrary } from "@/features/experiments/workspace-pages";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/experiments/")({
  validateSearch: uploadSearch,
  component: ExperimentsLibrary,
});
